





import { useEffect, useState } from "react";
import { getExEmployeesApi } from "../../app/api";
import { useNavigate } from "react-router-dom";
import { User } from "lucide-react";

const IMAGE_BASE_URL = "https://demouptask.visiontrek.io";

export default function ExEmployees() {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const navigate = useNavigate();
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadExEmployees = async () => {
    setLoading(true);
    const res = await getExEmployeesApi();
    if (res.success) {
      setEmployees(res.data || []);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadExEmployees();
  }, []);

  const filteredEmployees = employees.filter((emp) => {
    if (!emp.deleted_at) return true;

    const exitDate = new Date(emp.deleted_at);

    if (startDate && exitDate < new Date(startDate)) return false;
    if (endDate && exitDate > new Date(endDate)) return false;

    return true;
  });

  return (
    <div className="rounded-2xl md:mt-20 p-6 bg-[#12082F] text-white border border-white/10 shadow-2xl relative">

      {/* Glow */}
      <div className="absolute -top-10 -right-10 w-60 h-60 bg-purple-500/20 blur-3xl rounded-full" />
      <div className="absolute bottom-0 -left-10 w-60 h-60 bg-fuchsia-500/20 blur-3xl rounded-full" />

      {/* Header */}
      <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-3">
        <h3 className="text-2xl font-bold">Ex Employees</h3>

        <div className="flex  gap-2">
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="px-3 py-1.5 rounded-lg bg-white/10 border border-white/20 text-sm"
          />

          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="px-3 py-1.5 rounded-lg bg-white/10 border border-white/20 text-sm"
          />

          {/* <button
            onClick={() => {
              setStartDate("");
              setEndDate("");
            }}
            className="px-3 py-1.5 rounded-lg bg-red-500/80 hover:bg-red-500 text-sm"
          >
            Clear
          </button> */}
        </div>
          <button
            onClick={() => {
              setStartDate("");
              setEndDate("");
            }}
            className="px-3 py-1.5 rounded-lg bg-red-500/80 hover:bg-red-500 text-sm"
          >
            Clear
          </button>
      </div>

      {/* Table */}
      <div className="overflow-x-auto rounded-xl border border-white/10 bg-white/5 backdrop-blur-xl">
        <table className="w-full text-sm">
          <thead className="text-white/60 border-b border-white/10">
            <tr>
              <th className="text-left px-4 py-3">Name</th>
              <th className="text-left px-4 py-3">Email</th>
              <th className="text-left px-4 py-3">Role</th>
              <th className="text-left px-4 py-3">Job</th>
              <th className="text-left px-4 py-3">Exit Date</th>
            </tr>
          </thead>

          <tbody>
            {loading && (
              <tr>
                <td colSpan="5" className="py-6 text-center opacity-60">
                  Loading...
                </td>
              </tr>
            )}

            {!loading && filteredEmployees.length === 0 && (
              <tr>
                <td colSpan="5" className="py-6 text-center opacity-60">
                  No ex employees found
                </td>
              </tr>
            )}

            {!loading &&
              filteredEmployees.map((emp) => (
                <tr
                  key={emp.id}
                  className="border-b border-white/5 hover:bg-white/5 transition"
                >
                  {/* NAME */}
                  <td className="px-4 py-3">
                    <div
                      className="flex items-center gap-3 cursor-pointer"
                      // onClick={() => navigate(`/users/${emp.id}`)} // ✅ FIXED
                      onClick={() =>
                        navigate(`/users/${emp.id}`, { state: { user: emp } })
                      }
                    >
                      <div className="w-9 h-9 rounded-full bg-white/20 overflow-hidden">
                        {emp.profile_pic ? (
                          <img
                            src={`${IMAGE_BASE_URL}${emp.profile_pic}`}
                            className="w-full h-full object-cover"
                          />
                        ) : (
                          <div className="w-full h-full flex items-center justify-center bg-white/10">
                            <User size={16} className="text-white/60" />
                          </div>
                        )}
                      </div>

                      <span className="font-medium hover:text-blue-400">
                        {emp.first_name} {emp.last_name}
                      </span>
                    </div>
                  </td>

                  {/* EMAIL */}
                  <td className="px-4 py-3 opacity-80">
                    {emp.email}
                  </td>

                  {/* ROLE */}
                  <td className="px-4 py-3">
                    <span className="px-2 py-1 rounded-full bg-purple-500/20 text-purple-300 text-xs">
                      {emp.role_name || "-"}
                    </span>
                  </td>

                  {/* JOB */}
                  <td className="px-4 py-3">
                    {emp.job_title || "-"}
                  </td>

                  {/* EXIT DATE */}
                  <td className="px-4 py-3 opacity-70">
                    {emp.deleted_at
                      ? new Date(emp.deleted_at).toLocaleDateString("en-IN")
                      : "-"}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}





// import { useEffect, useState } from "react";
// import { getExEmployeesApi } from "../../app/api";
// import { useNavigate } from "react-router-dom";

// export default function ExEmployees() {

//   const [startDate, setStartDate] = useState("");
// const [endDate, setEndDate] = useState("");



//   const navigate = useNavigate();
//   const [employees, setEmployees] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const loadExEmployees = async () => {
//     setLoading(true);
//     const res = await getExEmployeesApi();
//     if (res.success) {
//       setEmployees(res.data || []);
//     }
//     setLoading(false);
//   };

//   useEffect(() => {
//     loadExEmployees();
//   }, []);



//   const filteredEmployees = employees.filter((emp) => {
//     if (!emp.deleted_at) return true;
  
//     const exitDate = new Date(emp.deleted_at);
  
//     if (startDate && exitDate < new Date(startDate)) return false;
//     if (endDate && exitDate > new Date(endDate)) return false;
  
//     return true;
//   });
  
  

//   return (
//     <div
//       className="
//       rounded-2xl
//       md:mt-20
//       p-5
//       bg-gradient-to-br
//       from-[#2d1c6a]
//       via-[#24155a]
//       to-[#12082f]
//       text-white
//       border border-white/10
//       shadow-2xl shadow-[#12082F]/60
//       relative
//     "
//     >
//       {/* glow */}
//       <div className="absolute -top-10 -right-10 w-60 h-60 bg-purple-500/20 blur-3xl rounded-full" />
//       <div className="absolute bottom-0 -left-10 w-60 h-60 bg-fuchsia-500/20 blur-3xl rounded-full" />

//       <h3 className="font-bold text-2xl  mb-4 relative z-10">
//         Ex Employees
//       </h3>


//       <div className="flex flex-col md:flex-row gap-3 mb-4">
  
//   <input
//     type="date"
//     value={startDate}
//     onChange={(e) => setStartDate(e.target.value)}
//     className="px-3 py-1 rounded-lg bg-white/10 border border-white/20 text-sm"
//   />

//   <input
//     type="date"
//     value={endDate}
//     onChange={(e) => setEndDate(e.target.value)}
//     className="px-3 py-1 rounded-lg bg-white/10 border border-white/20 text-sm"
//   />

//   <button
//     onClick={() => {
//       setStartDate("");
//       setEndDate("");
//     }}
//     className="px-3 py-1 rounded-lg bg-red-500/80 hover:bg-red-500 text-sm"
//   >
//     Clear
//   </button>

// </div>

//       {/* TABLE */}
//       <div className="max-h-[450px] overflow-y-auto">
//   <table className="w-full text-sm table-fixed">
//     <thead className="text-white/70 border-b border-white/10">
//       <tr>
//         <th className="text-left w-[220px] py-3 px-3">Name</th>
//         <th className="text-left w-[220px] py-3 px-3">Email</th>
//         <th className="text-left w-[120px] py-3 px-3">Gender</th>
//         <th className="text-left w-[180px] py-3 px-3">Job Title</th>
//         <th className="text-left w-[140px] py-3 px-3">Role</th>
//         <th className="text-left w-[150px] py-3 px-3">Exit Date</th>
//       </tr>
//     </thead>

//     <tbody>
//       {loading && (
//         <tr>
//           <td colSpan="6" className="py-6 text-center opacity-60">
//             Loading...
//           </td>
//         </tr>
//       )}

//       {!loading && employees.length === 0 && (
//         <tr>
//           <td colSpan="6" className="py-6 text-center opacity-60">
//             No ex employees found
//           </td>
//         </tr>
//       )}

//       {!loading &&
//         filteredEmployees.map((emp) => (
//           <tr
//             key={emp.id}
//             className="border-b border-white/5 hover:bg-white/5"
//           >
//             {/* NAME */}
//             <td className="w-[220px] py-3 px-3">
//               <button
//                 onClick={() => navigate(`/users/${emp.id}`)}
//                 className="font-medium truncate text-blue-300 hover:underline"
//               >
//                 {emp.first_name} {emp.last_name}
//               </button>
//             </td>

//             {/* EMAIL */}
//             <td className="py-3 px-3 opacity-80 truncate">
//               {emp.email}
//             </td>

//             {/* GENDER */}
//             <td className="py-3 px-3 capitalize">
//               {emp.gender || "-"}
//             </td>

//             {/* JOB TITLE */}
//             <td className="py-3 px-3">
//               {emp.job_title || "-"}
//             </td>

//             {/* ROLE */}
//             <td className="py-3 px-3">
//               <span className="px-3 py-1 rounded-full bg-purple-500/20 text-purple-300 text-xs">
//                 {emp.role_name || "-"}
//               </span>
//             </td>

//             {/* EXIT DATE */}
//             <td className="py-3 px-3 opacity-80">
//               {emp.deleted_at
//                 ? new Date(emp.deleted_at).toLocaleDateString()
//                 : "-"}
//             </td>
//           </tr>
//         ))}
//     </tbody>
//   </table>
// </div>
//     </div>
//   );
// }
